import React, { useState } from 'react';
import { TextField } from '@mui/material';

const EditableCell = ({ value, onChange }) => {
  const [editedValue, setEditedValue] = useState(value);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setEditedValue(newValue);
    onChange(newValue);
  };

  return (
    <TextField
      fullWidth
      value={editedValue}
      onChange={handleChange}
      variant="outlined"
      size="small"
    />
  );
};

export default EditableCell;
